import { createSSRApp } from "vue";
import App from "./App.vue";
import 'uno.css';

import store, { useUserStore } from './store';
import { uTools } from '@/libs';
import { prototypeInterceptor, requestInterceptor } from './interceptors';
import { setUnauthorizedHandler } from '@/utils/http';

uni.$onLaunched = new Promise((resolve) => {
  uni.$isResolve = resolve;
});

export function createApp() {
  const app = createSSRApp(App);
  uni.$c = {};
  uni.isInited = 'padding'; // 初始化标识
  uni.isLoggedIn = false; // 登录标识

  app.use(uTools);
  app.use(store);
  app.use(prototypeInterceptor);
  app.use(requestInterceptor);


  // 注册 401 处理回调，打破循环依赖
  setUnauthorizedHandler(() => useUserStore());

  return {
    app,
  };
}
